// Shopify-only adapter. Backend values override the preserved review snapshot.
// Keep the standalone local draft independent of Shopify.
// Shopify strips the preview selector on arrival; retain it for reload/bookmark safety.
if(window.discographyThemeId){const previewUrl=new URL(location.href);previewUrl.searchParams.set('preview_theme_id',String(window.discographyThemeId));history.replaceState(null,'',previewUrl);}
const backendReleases=JSON.parse(document.querySelector('#discography-backend')?.textContent||'[]');
const backendReleaseDetails=JSON.parse(document.querySelector('#discography-release-details')?.textContent||'[]');
const handleAliases={'untitled-1':'untitled-ep','cleos-ferry-cemetry':'cleos-ferry','east-enders-wives-maxi-single':'east-enders-wives'};
for(const record of backendReleases){
 const id=handleAliases[record.handle]||record.handle;
 const r=releaseData.find(item=>item.id===id);if(!r)continue;
 const archived=record.archive;
 if(archived?.release)Object.assign(r,archived.release);
 if(archived?.credits)archiveData[id]=archived.credits;
 if(archived?.lyrics)Object.assign(dropboxLyrics,archived.lyrics);
 if(archived?.shopifyLyrics)Object.assign(lyricsData,archived.shopifyLyrics);
 if(archived?.artwork){for(let i=artworkData.length-1;i>=0;i--)if(artworkData[i].release===id)artworkData.splice(i,1);artworkData.push(...archived.artwork);}
 if(record.title)r.title=record.title;
 if(record.cover)r.cover=record.cover;
 r.synopsis=record.synopsis||'';
 r.synopsisHtml=record.synopsisHtml||'';
 if(record.category){r.type=record.category;r.kind=({studio:'Full-length',ep:'EP',single:'Single',live:'Live album'})[r.type]||r.type;}
 if(record.sequence)r.sequence=record.sequence;
 const editorial=record.editorial||{};
 if(Object.values(editorial).some(v=>v!==null&&v!=='')){
  const a=archiveData[id]||(archiveData[id]={edition:'',copyrightYear:'',sourcePath:'',pages:[],credits:[],sections:[]});
  for(const [key,value] of [['edition',editorial.edition],['copyrightYear',editorial.copyrightYear],['sourcePath',editorial.source]])if(value!==null)a[key]=value;
  for(const [title,value,test] of [['Full credits',editorial.credits,/^(Full credits|Complete credits|Complete album credits|Production, artwork)/i],['Thank-yous',editorial.thanks,/thank/i],['Release history',editorial.history,/release history/i]]){
   if(value===null||value===undefined)continue;
   a.sections=a.sections.filter(s=>!test.test(s.title));if(value)a.sections.push({title,text:value});
  }
 }
 // Dedicated metaobject fields are authoritative: clearing a credit clears the page.
 r.summary=Object.fromEntries(Object.entries(record.summary||{}).map(([key,value])=>[key,value??'']));
 const details=backendReleaseDetails.find(detail=>detail.releaseHandle===record.handle);
 r.summary.cover_art_by=details?.cover_art_by||'';
 r.summary.release_date=details?.release_date||'';
 r.coverCaption=details?.cover_caption||'';
 r.artworkCaptions={bandLogo:details?.band_logo_caption||'',albumLogo:details?.album_logo_caption||'',sticker:details?.record_sticker_caption||''};
 if(record.summary?.year){r.year=String(record.summary.year);r.displayYear=r.year;r.sortYear=Number(r.year);}
 for(const [key,value] of Object.entries(record.links||{}))if(value)r.fields[key]=value;
 r.uploadedArtwork={};
 for(const key of ['albumLogo','bandLogo','labelLogo','sticker'])if(record[key]){r[key]=record[key];r.uploadedArtwork[key]=record[key];}
 if(record.tracks?.length){
  for(const track of record.tracks){
   const parts=[track.hours,track.minutes,track.seconds];
   if(parts.some(value=>value!==null&&value!==undefined&&value!=='')){
    const values=parts.map(value=>Number(value||0));
    track.duration=values.every(value=>Number.isInteger(value)&&value>=0)?values[0]*3600+values[1]*60+values[2]:null;
   }
  }
  r.trackEntries=record.tracks;
  // A hidden recording included inside a numbered track shares that track's runtime.
  const timedTracks=record.tracks.filter(track=>!track.parentId||!record.tracks.some(parent=>!parent.hidden&&parent.id===track.parentId));
  if(timedTracks.every(track=>track.duration!==null&&track.duration!==undefined&&track.duration!==''))r.summary.runtime_seconds=timedTracks.reduce((total,track)=>total+Number(track.duration),0);
  const listed=record.tracks.filter(t=>!t.hidden);
  r.tracks=r.withheld?[]:listed.map(t=>t.title);
  r.hiddenTracks=record.tracks.filter(t=>t.hidden).length;
  if(r.withheld&&archiveData[id]?.spoiler)archiveData[id].spoiler.tracks=listed.map(t=>t.title);
  for(const t of listed){if(t.lyrics)dropboxLyrics[id+'::'+t.title.toLowerCase().replace(/[^a-z0-9]/g,'')]={text:t.lyrics,sourceTitle:t.source||'Shopify track entry',sourcePath:t.source||'Edited in Shopify'};}
 }
}
const resolveAsset=p=>window.discographyAssets?.[p]||p;
for(const r of releaseData){for(const key of ['cover','bandLogo','albumLogo','labelLogo','sticker'])r[key]=resolveAsset(r[key]);for(const a of r.assets||[])a.path=resolveAsset(a.path);}
for(const a of artworkData)a.preview=resolveAsset(a.preview);
